import { memo } from 'react';
import PropTypes from 'prop-types';
import RecursionRenderer from '../../../RecursionRenderer';
import withCurrentData from './withCurrentData';

const CustomCellRenderer = memo(function CustomCellRenderer(props) {
  const { fields, context, api, colDef } = props;

  if (!Array.isArray(fields) || fields.length === 0) {
    return null;
  }

  const columnDefs = api.getColumnDefs();
  const { tableKeyPath } = context;
  const colIndex = columnDefs.findIndex((col) => col.colId === colDef.colId);

  return (
    <RecursionRenderer
      fields={fields}
      keyPath={`${tableKeyPath},componentProps,columnDefs,${colIndex},cellRendererParams,fields`}
    />
  );
});

CustomCellRenderer.propTypes = {
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      component: PropTypes.string,
      componentProps: PropTypes.shape({}),
    }),
  ),
  context: PropTypes.shape({
    tableKeyPath: PropTypes.string,
  }),
  api: PropTypes.shape({
    getColumnDefs: PropTypes.func,
  }),
  colDef: PropTypes.shape({
    colId: PropTypes.string,
  }),
};

export default withCurrentData(CustomCellRenderer);
